import cx from 'classnames';
import styles from './../Pricing.module.scss';
import { Form } from 'react-bootstrap';
import { getBillingCycleName } from '../subscriptionComponents/subscriptionHelper';
import Wrapper from '../subscriptionComponents/Wrapper';

export const Billing = ({ title, children, className = '', style = {} }) => {
  return (
    <Wrapper
      className={cx('p-4 bg-white', className)}
      childrenClassName="flex-column gap-2"
      title={title}
      style={style}>
      {children}
    </Wrapper>
  );
};

export const BillingCycle = ({ selected, title, price, cycle, onClick, floatingText = '' }) => {
  return (
    <div className={cx(styles.billingCycle, selected ? styles.selected : '')} onClick={onClick}>
      <Form.Check
        type="radio"
        className={cx(styles.formCheck, selected ? styles.checked : '', 'mb-0')}>
        <Form.Check.Input type="radio" name="group" checked={selected} onChange={(e) => e} />
        <Form.Check.Label className="px-2">
          <h6 className={styles.name}>{title}</h6>
          <p className={styles.price}>
            ${price} / {getBillingCycleName({ cycle, shortName: true })?.toLowerCase()}
          </p>
        </Form.Check.Label>
        {floatingText ? <p className={styles.floatingText}>{floatingText}</p> : null}
      </Form.Check>
    </div>
  );
};
